<template>
    <div class="video-maker-vue" 
        v-on-resize
    >
        <router-view />
    </div>
    
</template>

<script>
import set_width_svg from "@/components/player-editor/modules/set_width_svg";
import set_settings from "@/App/modules/set_settings";

export default {
  mounted() {

    let str = 'Delaweb - Frontend: Nosov Vyacheslav'
    console.log('%c%s', 'background-color: #1d427b; padding: 4px 10px; color: white' ,str)
    console.log('%c%s', 'background-color: #1d427b; padding: 4px 10px; color: white' , 'https://delaweb.ru/')

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    set_width_svg()
    // получаем настройки приложения
    set_settings(this)
  },
  data() {
    return {
      transitionName: 'right-slide'
    }
  },
  directives: {
    onResize: {
      inserted: (el, binding, vnode) => {
        window.onresize = () => {
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);

          vnode.context.set_width_svg()
        }
      }
    }
  },
  methods: {
    set_width_svg
  }
}
</script>

<style lang="less">
    @import '../assets/smart-grid.less';

    * {
        box-sizing: border-box;
    }
        

    .video-maker-vue {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        user-select: none;
        background-color: black;
    }
        
    .fade-menu-enter-active {
        animation: fade-menu .3s ease;
    }
        

    .fade-menu-leave-active {
        animation: fade-menu .3s ease reverse;
    }

    @keyframes fade-menu {
        0% {
            opacity: 0;
            right: -300px;
        }
        100% {
            opacity: 1;
            right: 0px;
        }
    }

    .default-fade-enter-active {
        animation: default-fade .2s linear;
    }
        

    .default-fade-leave-active {
        animation: default-fade .2s linear reverse;
    }

    @keyframes default-fade {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    .fade-overlay-enter-active {
        animation: fade-overlay .2s linear;
    }
        

    .fade-overlay-leave-active {
        animation: fade-overlay .2s linear reverse;
    }

    @keyframes fade-overlay {
        0% {
            opacity: 0;
        }
        100% {
            opacity: .7;
        }
    }

    @keyframes text-rotate {
        0% {
            margin-left: calc(var(--widthVideo) + var(--widthVideo) / 2);
        }

        100% {
            margin-left: var(--textMargin);
        }
    }

        
    
    
</style>